import { PARENT_CHECKOUT_PATH } from '@/lib/defaults';

/**
 * Session Replay Configuration
 * Controls PostHog session recording behavior and sampling rates
 */

export const SESSION_REPLAY_CONFIG = {
    // Environment controls
    enableInProduction: true,
    enableInPreview: false,
    enableInDevelopment: false,

    // Sampling rates by page category
    samplingRates: {
        checkout: 1.0, // 100% - Critical conversion pages
        onboarding: 1.0, // 100% - Critical signup flow
        homepage: 0.8, // 80% - High traffic landing page
        landing: 0.8, // 80% - Other landing pages
        default: 0.4, // 40% - Base coverage for all pages
    },

    // Quality filters
    minimumDuration: 5000, // 5 seconds - filter bounces
    excludeBots: true, // Filter bot traffic
    respectOptOut: true, // Honor opt-out cookie

    // Privacy settings (inherit from existing config)
    maskAllInputs: true,
    maskTextSelector: '[data-private]',
    recordConsole: true, // Capture console logs
    recordNetwork: true, // Record network requests for better replay quality

    // Path pattern definitions
    highPriorityPaths: [
        '/checkout-v2',
        PARENT_CHECKOUT_PATH,
        '/onboarding',
        '/signup',
        '/school-onboard',
        '/summer-slide-checkout',
    ],

    landingPaths: [
        '/',
        '/parents',
        '/teachers',
        '/pricing',
    ],
} as const;

export type SessionReplayConfig = typeof SESSION_REPLAY_CONFIG;
